
import Request from '../../../../src/core/gd/data/request'
import {RequestType} from "../data/types";

export default class ApiBigScreen {

    newScreen(companyId:ID, deviceId:ID, params:any) {
        return new Request(this, 'POST', 'company/' + companyId + '/big-screen/' + deviceId + '/screens', params);
    }


    static newDevice(params:any):Request {
        return new Request(this, RequestType.POST, 'company/'+gd.companyId+'/big-screens', params)
                  // const res = new ApiCall(this,'post','company/'+this.organization.id+'/big-screens',{
                  //       name: params.name
                  //   });
    }
    static getDevice(deviceId:ID):Request {
        return new Request(this, RequestType.GET, 'company/'+gd.companyId+'/big-screen/'+deviceId)

    }
    static updateDevice(deviceId:ID, params: any):Request {
        return new Request(this, RequestType.PUT, 'company/'+gd.companyId+'/big-screen/'+deviceId, params)
                    //   const res = new ApiCall(this,'put','company/'+this.organization.id+'/big-screen/'+device.id,{
                    //     name: params.name
                    // });

    }
    static listDevices():Request {
        return new Request(this, RequestType.GET, 'company/'+gd.companyId+'/big-screens')
    }

    static deleteScreen(deviceId:ID, screenId: ID):Request {
        return new Request(this, RequestType.DELETE, 'company/'+gd.companyId+'/big-screen/'+deviceId+'/screen/'+screenId);
    }

    static deleteDevice(deviceId:ID):Request {
        return new Request(this, RequestType.DELETE, 'company/'+gd.companyId+'/big-screen/'+deviceId);
    }

    static updateDeviceScreens(deviceId:ID, params: any):Request {
        return new Request(this,RequestType.PUT,'company/'+gd.companyId+'/big-screen/'+deviceId+'/screens',params);
    }

}

